import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DestroySubscribers } from '../../../../decorators/destroy-subscribers.decorator';

@Component({
  selector: 'gtd-earning-convert-error',
  templateUrl: './earning-convert-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EarningConvertErrorComponent),
      multi: true,
    },
  ],
})
@DestroySubscribers()
export class EarningConvertErrorComponent implements ControlValueAccessor, OnInit {
  @Input() exchangeFieldControl: FormControl;
  public unConvertedIds: number[] = [];
  public onChange: () => void;
  public onTouched: () => void;

  private subscribers: any = {};

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscribers.exchangeFieldControl = this.exchangeFieldControl.valueChanges.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(ids: number[]): void {
    this.unConvertedIds = ids;
    this.cdr.markForCheck();
  }
}
